// import { Router, ActivatedRoute } from '@angular/router';
// import {
//   GetPlateOperationReport,
//   PlateOperationReportProps,
// } from '../model/plate-operation/plateOperationReport';
// import { BarsDatasetType } from '../shared/components/bars-dataset/bars-dataset.component';
import dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
// import { PagedParams } from '../model/pagedParams';
// import { HttpParams } from '@angular/common/http';
// import ExcelJS from 'exceljs';

dayjs.extend((utc as any).default || utc);

// export function mergeQueryParams(
//   router: Router,
//   route: ActivatedRoute,
//   params: Record<string, any>
// ): void {
//   router.navigate([], {
//     relativeTo: route,
//     queryParams: params,
//     queryParamsHandling: 'merge',
//   });
// }

export function dateFormatter(date: string | null, dateOnly: boolean = false) {
  if (!date) {
    return '';
  }
  if (dayjs.utc(date).year() < 2000) {
    return '';
  }
  // date is only date only
  if (date.length === 10) {
    return dayjs(date).format('MM/DD/YYYY');
  }
  if (dateOnly) {
    return dayjs.utc(date).local().format('MM/DD/YYYY');
  }
  return dayjs.utc(date).local().format('HH:mm MM/DD/YYYY ');
}

// export function getPercentage(
//   value: number | null,
//   total: number | null,
//   decimalPlaces: number = 2
// ) {
//   if (value === null || total === null || total === 0) {
//     return '0.00%';
//   }
//   return ((value / total) * 100).toFixed(decimalPlaces) + '%';
// }

// export function deleteEmptyKeys(obj: Record<string, any>): Record<string, any> {
//   return Object.fromEntries(
//     Object.entries(obj).filter(
//       ([_, value]) => value !== null && value !== undefined
//     )
//   );
// }

// export const buildOperationChartDataByTimeFrame = (
//   operationReport: GetPlateOperationReport,
//   dateToFindWeek: string,
//   type: 'weekly' | 'monthly' = 'weekly'
// ): PlateOperationReportProps => {
//   let firstDayOfWeek = new Date(dateToFindWeek);
//   firstDayOfWeek.setDate(
//     firstDayOfWeek.getDate() - firstDayOfWeek.getDay() + 1
//   );
//   let lastDayOfWeek = new Date(dateToFindWeek);
//   lastDayOfWeek.setDate(lastDayOfWeek.getDate() + 7);

//   if (type === 'monthly') {
//     firstDayOfWeek = new Date(
//       firstDayOfWeek.getFullYear(),
//       firstDayOfWeek.getMonth(),
//       1
//     );
//     lastDayOfWeek = new Date(
//       firstDayOfWeek.getFullYear(),
//       firstDayOfWeek.getMonth() + 1,
//       0
//     );
//   }

//   const totalDays =
//     type === 'weekly'
//       ? 7
//       : lastDayOfWeek.getDate() - firstDayOfWeek.getDate() + 1;

//   const receivingVsPrimingData: BarsDatasetType[] = [];
//   const primingVsSYReceivingData: BarsDatasetType[] = [];
//   const SYReceivingVsCuttingData: BarsDatasetType[] = [];

//   const receivingData: BarsDatasetType[] = [];
//   const primingData: BarsDatasetType[] = [];
//   const syReceivingData: BarsDatasetType[] = [];
//   const edgeMillingData: BarsDatasetType[] = [];
//   const cuttingData: BarsDatasetType[] = [];
//   const flaggedPlateInspectionCountsByDate: BarsDatasetType[] = [];

//   for (let i = 0; i <= totalDays - 1; i++) {
//     const date = new Date(firstDayOfWeek.getTime() + i * 24 * 60 * 60 * 1000);
//     const weekDate = date.toLocaleDateString().split('/').slice(0, 2).join('/');
//     const primingCount = operationReport.platePrimingCountsByDate.find(
//       (item) => new Date(item.date).getTime() === date.getTime()
//     )?.totalCount;
//     const receivingCount = operationReport.plateReceivingCountsByDate.find(
//       (item) => new Date(item.date).getTime() === date.getTime()
//     )?.totalCount;
//     const syReceivingCount = operationReport.syPlateReceivingCountsByDate.find(
//       (item) => new Date(item.date).getTime() === date.getTime()
//     )?.totalCount;
//     const cuttingCount = operationReport.plateCuttingCountByDate?.find(
//       (item) => new Date(item.date).getTime() === date.getTime()
//     )?.totalCount;
//     const edgeMillingCount = operationReport.plateEdgeMillingCountByDate?.find(
//       (item) => new Date(item.date).getTime() === date.getTime()
//     )?.totalCount;
//     const flaggedInspectionCount =
//       operationReport.flaggedPlateInspectionCountsByDate?.find(
//         (item) => new Date(item.date).getTime() === date.getTime()
//       )?.totalCount;

//     receivingVsPrimingData.push({
//       date: weekDate,
//       receivings: receivingCount ? receivingCount : 0,
//       primings: primingCount ? primingCount : 0,
//     });
//     primingVsSYReceivingData.push({
//       date: weekDate,
//       primings: primingCount ? primingCount : 0,
//       syReceivings: syReceivingCount ? syReceivingCount : 0,
//     });
//     SYReceivingVsCuttingData.push({
//       date: weekDate,
//       syReceivings: syReceivingCount ? syReceivingCount : 0,
//       cutting: cuttingCount ? cuttingCount : 0,
//     });

//     receivingData.push({
//       date: weekDate,
//       count: receivingCount ? receivingCount : 0,
//     });
//     primingData.push({
//       date: weekDate,
//       count: primingCount ? primingCount : 0,
//     });
//     syReceivingData.push({
//       date: weekDate,
//       count: syReceivingCount ? syReceivingCount : 0,
//     });
//     edgeMillingData.push({
//       date: weekDate,
//       count: edgeMillingCount ? edgeMillingCount : 0,
//     });
//     cuttingData.push({
//       date: weekDate,
//       count: cuttingCount ? cuttingCount : 0,
//     });
//     flaggedPlateInspectionCountsByDate.push({
//       date: weekDate,
//       count: flaggedInspectionCount ? flaggedInspectionCount : 0,
//     });
//   }

//   return {
//     receivingData,
//     primingData,
//     syReceivingData,
//     edgeMillingData,
//     cuttingData,
//     receivingVsPrimingData: receivingVsPrimingData,
//     primingVsSYReceivingData: primingVsSYReceivingData,
//     SYReceivingVsCuttingData: SYReceivingVsCuttingData,
//     flaggedPlateInspectionData: flaggedPlateInspectionCountsByDate,
//   };
// };

// export const getPercentageColor = (value: number): string => {
//   if (value === 1) {
//     return 'rgb(0, 180, 48)';
//   } else if (value > 0.8) {
//     return 'rgb(101, 225, 101)';
//   } else if (value > 0.6) {
//     return 'rgb(173, 222, 33)';
//   } else if (value > 0.4) {
//     return 'rgb(255, 193, 7)';
//   } else if (value > 0.2) {
//     return 'rgb(255, 87, 34)';
//   }
//   return 'inherit';
// };

// export const getInspectionString = (
//   originalString: string | number | null,
//   inspectedString: string | number | null
// ) => {
//   if (!inspectedString) return originalString;
//   return originalString + ' (' + inspectedString + ')';
// };

// export const getParamsFromQueryParams = (
//   queryParams: PagedParams
// ): HttpParams => {
//   let params = new HttpParams();
//   params = params.set('pageNumber', queryParams.pageNumber.toString());
//   params = params.set('pageSize', queryParams.pageSize.toString());
//   params = params.set('orderBy', queryParams.orderBy);
//   if (queryParams.startDate) {
//     params = params.set('startDate', queryParams.startDate.toString());
//   }
//   if (queryParams.endDate) {
//     params = params.set('endDate', queryParams.endDate.toString());
//   }
//   if (queryParams.searchTerm) {
//     params = params.set('searchTerm', queryParams.searchTerm);
//   }
//   return params;
// };

// export const getSteelWeight = (
//   length: number,
//   width: number,
//   thickness: number,
//   quantity: number = 1
// ): number => {
//   const density = 7.85; // Density of steel in g/cm³
//   const volume = (length * width * thickness) / 1000000; // Convert mm³ to m³
//   return volume * density * quantity; // Weight in kg
// };

// export const excelRowFormatter = (
//   row: ExcelJS.Row,
//   backgroundColor: string,
//   bold: boolean = false
// ) => {
//   const borderStyle = {
//     top: { style: 'thin' },
//     left: { style: 'thin' },
//     bottom: { style: 'thin' },
//     right: { style: 'thin' },
//   };

//   row.height = 18;
//   row.eachCell((cell: ExcelJS.Cell, colNumber) => {
//     if (colNumber < 10) {
//       if (colNumber === 4) {
//         if (typeof cell.value === 'string' || typeof cell.value === 'number') {
//           const floatValue = parseFloat(cell.value as string);
//           if (!isNaN(floatValue)) {
//             cell.numFmt = '#.0';
//             cell.value = floatValue;
//           }
//         }
//       }
//       if (colNumber === 8) {
//         if (
//           typeof cell.value === 'string' || typeof cell.value === 'number'
//             ? parseInt(cell.value as string)
//             : 0 || cell.formula
//         ) {
//           cell.numFmt = '#,##0';
//         }
//       }

//       if (colNumber === 9) {
//         // date format to march 1, 2021
//         // if (cell.value) cell.value = new Date(cell.value);
//         if (
//           cell.value !== undefined &&
//           new Date(cell.value as string | number | Date).toString() !==
//             'Invalid Date'
//         ) {
//           cell.value = new Date(cell.value as string | number | Date);
//           console.log(cell.value);
//         }
//         cell.numFmt = 'mmmm d, yyyy';
//       }

//       cell.font = { name: 'Arial', size: 10 };
//       cell.fill = {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: { argb: backgroundColor }, // Light orange background color
//       };

//       cell.border = borderStyle as ExcelJS.Borders;
//       if (bold) cell.font.bold = true;
//       // Align text to the right for the thickness column
//       if (
//         ((typeof cell.value === 'string' || typeof cell.value === 'number') &&
//           parseInt(cell.value as string) &&
//           colNumber !== 1 &&
//           colNumber !== 2) ||
//         cell.formula
//       )
//         cell.alignment = { horizontal: 'right', vertical: 'middle' };
//       else cell.alignment = { horizontal: 'center', vertical: 'middle' };
//     }
//   });
// };
